document.addEventListener('DOMContentLoaded', function() {

    const sliderContent = document.querySelector('.slider-content');
    const slides = document.querySelectorAll('.swiper-slide');
    const navItems = document.querySelectorAll('.nav-item-wrapper');

    if (!slides.length || !navItems.length) {
        console.error('Slides or nav items not found');
        return;
    }

    let currentIndex = 0;

    // Создаем лайтбокс
    const lightbox = document.createElement('div');
    lightbox.className = 'lightbox';
    lightbox.innerHTML = `
        <div class="lightbox-overlay"></div>
        <div class="lightbox-content">
            <button class="lightbox-close">&times;</button>
            <button class="lightbox-prev">&lsaquo;</button>
            <button class="lightbox-next">&rsaquo;</button>
            <img src="" alt="" class="lightbox-image">
            <div class="lightbox-counter"></div>
        </div>
    `;
    document.body.appendChild(lightbox);

    const lightboxImage = lightbox.querySelector('.lightbox-image');
    const lightboxCounter = lightbox.querySelector('.lightbox-counter');
    const lightboxClose = lightbox.querySelector('.lightbox-close');
    const lightboxPrev = lightbox.querySelector('.lightbox-prev');
    const lightboxNext = lightbox.querySelector('.lightbox-next');
    const lightboxOverlay = lightbox.querySelector('.lightbox-overlay');

    let lightboxIndex = 0;

    function showSlide(index) {
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;

        currentIndex = index;

        slides.forEach((slide, i) => {
            if (i === index) {
                slide.style.display = 'flex';
                slide.style.opacity = '1';
            } else {
                slide.style.display = 'none';
                slide.style.opacity = '0';
            }
        });

        updateNav(index);
    }

    function updateNav(index) {
        navItems.forEach((item, i) => {
            if (i === index) {
                item.classList.add('active');
            } else {
                item.classList.remove('active');
            }
        });
    }

    // Открытие лайтбокса
    function openLightbox(index) {
        lightboxIndex = index;
        const img = slides[index].querySelector('img');
        if (img) {
            lightboxImage.src = img.src;
            lightboxImage.alt = img.alt;
            updateLightboxCounter();
            lightbox.classList.add('active');
            document.body.style.overflow = 'hidden';
        }
    }

    // Закрытие лайтбокса
    function closeLightbox() {
        lightbox.classList.remove('active');
        document.body.style.overflow = '';
        lightboxImage.src = '';
    }

    // Навигация в лайтбоксе
    function lightboxPrevSlide() {
        lightboxIndex = (lightboxIndex - 1 + slides.length) % slides.length;
        const img = slides[lightboxIndex].querySelector('img');
        if (img) {
            lightboxImage.src = img.src;
            lightboxImage.alt = img.alt;
            updateLightboxCounter();
        }
    }

    function lightboxNextSlide() {
        lightboxIndex = (lightboxIndex + 1) % slides.length;
        const img = slides[lightboxIndex].querySelector('img');
        if (img) {
            lightboxImage.src = img.src;
            lightboxImage.alt = img.alt;
            updateLightboxCounter();
        }
    }

    function updateLightboxCounter() {
        lightboxCounter.textContent = `${lightboxIndex + 1} / ${slides.length}`;
    }

    // Клики по изображениям для открытия лайтбокса
    slides.forEach((slide, index) => {
        const img = slide.querySelector('img');
        if (img) {
            img.style.cursor = 'pointer';
            img.addEventListener('click', function(e) {
                e.stopPropagation();
                openLightbox(index);
            });
        }
    });

    // Обработчики лайтбокса
    lightboxClose.addEventListener('click', closeLightbox);
    lightboxOverlay.addEventListener('click', closeLightbox);
    lightboxPrev.addEventListener('click', lightboxPrevSlide);
    lightboxNext.addEventListener('click', lightboxNextSlide);

    // Закрытие по Escape
    document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && lightbox.classList.contains('active')) {
            closeLightbox();
        }
        if (e.key === 'ArrowLeft' && lightbox.classList.contains('active')) {
            lightboxPrevSlide();
        }
        if (e.key === 'ArrowRight' && lightbox.classList.contains('active')) {
            lightboxNextSlide();
        }
        // Навигация по слайдеру когда лайтбокс закрыт
        if (!lightbox.classList.contains('active') && sliderContent.offsetParent !== null) {
            if (e.key === 'ArrowRight') {
                showSlide(currentIndex + 1);
            } else if (e.key === 'ArrowLeft') {
                showSlide(currentIndex - 1);
            }
        }
    });

    // Клики по навигации
    navItems.forEach((item, index) => {
        item.addEventListener('click', function() {
            showSlide(index);
        });
    });

    // Свайпы на мобильных устройствах
    let touchStartX = 0;
    let touchEndX = 0;

    sliderContent.addEventListener('touchstart', (e) => {
        touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    sliderContent.addEventListener('touchend', (e) => {
        touchEndX = e.changedTouches[0].screenX;
        handleSwipe();
    }, { passive: true });

    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = touchStartX - touchEndX;

        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                showSlide(currentIndex + 1);
            } else {
                showSlide(currentIndex - 1);
            }
        }
    }

    // Инициализация
    showSlide(0);

    console.log('Custom slider with lightbox initialized');
});
window.addEventListener('scroll', () => {
    const header = document.getElementById('main-header');
    const header_hidden = document.getElementById('main-header-hidden');

    if (window.scrollY > 50) {
        header_hidden.classList.add('header-scrolled');
        header.classList.add('header-no-visible');
    } else {
        header_hidden.classList.remove('header-scrolled');
        header.classList.remove('header-no-visible');
    }
});
document.addEventListener('DOMContentLoaded', function() {
    const menuToggle = document.getElementById('menuToggle');
    const menuClose = document.getElementById('menuClose');
    const mobileMenu = document.getElementById('mobileMenu');
    const mobileNavLinks = document.querySelectorAll('.mobile-nav-link');
    const body = document.body;

    // Функция открытия
    function openMenu() {
        mobileMenu.classList.add('active');
        body.classList.add('no-scroll');
    }

    // Функция закрытия
    function closeMenu() {
        mobileMenu.classList.remove('active');
        body.classList.remove('no-scroll');
    }

    // События
    menuToggle.addEventListener('click', openMenu);
    menuClose.addEventListener('click', closeMenu);

    // Закрытие при клике на любую ссылку меню
    mobileNavLinks.forEach(link => {
        link.addEventListener('click', closeMenu);
    });

    // Закрытие при клике вне ссылок (на пустое место в меню)
    // mobileMenu.addEventListener('click', function(e) {
    //   if (e.target === this) {
    //     closeMenu();
    //   }
    // });
});